import { render } from "./AdminUsefulLinks.vue?vue&type=template&id=ccbfc3ea&scoped=true&ts=true"
import script from "./AdminUsefulLinks.vue?vue&type=script&lang=ts"
export * from "./AdminUsefulLinks.vue?vue&type=script&lang=ts"

import "./AdminUsefulLinks.vue?vue&type=style&index=0&id=ccbfc3ea&scoped=true&lang=css"
import "./AdminUsefulLinks.vue?vue&type=style&index=1&id=ccbfc3ea&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ccbfc3ea"]])

export default __exports__